import { locKeys } from "components/flexComponents/FlightsStructuredTable/l10n";
import { useLocalization } from "@shared-ui/localization-context";

export function getFlightDuration(hours: number, minutes: number): string {
  const { formatText } = useLocalization();
  if (hours < 1 && minutes >= 1) {
    return formatText(locKeys.minutes, minutes);
  }
  if (hours >= 1 && minutes < 1) {
    return formatText(locKeys.hours, hours);
  }
  return formatText(locKeys.hoursMinutes, hours, minutes);
}
